import { render, staticRenderFns } from "./ContractFormat.vue?vue&type=template&id=052c2b7d&scoped=true&"
import script from "./ContractFormat.vue?vue&type=script&lang=js&"
export * from "./ContractFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c2b7d",
  null
  
)

export default component.exports